export var HexPosition;
(function (HexPosition) {
    HexPosition[HexPosition["Subject"] = 0] = "Subject";
    HexPosition[HexPosition["Predicate"] = 1] = "Predicate";
    HexPosition[HexPosition["Value"] = 2] = "Value";
    HexPosition[HexPosition["Datatype"] = 3] = "Datatype";
    HexPosition[HexPosition["Language"] = 4] = "Language";
    HexPosition[HexPosition["Graph"] = 5] = "Graph";
})(HexPosition || (HexPosition = {}));
